function initCartBlocker() {
    let checkoutCartButton = document.querySelector('.cart-drawer__footer button[type="submit"]');

      if(document.getElementById('checkout_terms_agree')) {
      if(document.getElementById('checkout_terms_agree').checked) {
        document.getElementById('cartDrawerCheckoutBlocker').style.display = 'none';
      } else {
        if(checkoutCartButton !== null) {
          
          document.getElementById('checkout_terms_agree').addEventListener( 'click', function(){
              if(document.getElementById('checkout_terms_agree').checked) {
                document.getElementById('cartDrawerCheckoutBlocker').style.display = 'none';
              } else {
                document.getElementById('cartDrawerCheckoutBlocker').style.display = 'block';
              }
          });

          document.getElementById('cartDrawerCheckoutBlocker').addEventListener( 'click', function(){
            document.getElementById('cartCheckboxContainer').classList.add('highlightText');
            setTimeout(() => {
              document.getElementById('cartCheckboxContainer').classList.remove('highlightText');
            }, "5000");
          });
          

        }
      }
    }
}



function copyLink() {
    event.preventDefault();
    var linkButton = document.getElementById("sharebutton");
    if(navigator.clipboard) {
        navigator.clipboard.writeText(linkButton.href);
        linkButton.innerHTML = "Link Copied";
        linkButton.classList.add("copied");
    }
}

function resetProductPage() {
    $("input.message-input-wrapper").each(function() {
        this.value = '';
        $(this).hide();
    });

    $("input.card-message").each(function() {
        this.value = '';
    });

    $(".upsell-checkbox input").each(function() {
        this.checked = false;
        upsellProducts = [];
    });

    $("#upsellTimeStamp").val($.now());
    $("#itemTimestamp").val($.now());

    $("quantity-selector.quantity-selector").show();

    document.dispatchEvent(new CustomEvent("cart:refresh"));
}

async function checkForUpsellProducts() {

    if(document.getElementById('upsellTimeStamp')) {
        var formData = {items: []}
        var timestamp = document.getElementById('upsellTimeStamp').value;
        for (let i = 0; i < upsellProducts.length; i++) {
            formData.items.push({
                'id': upsellProducts[i],
                'quantity': 1,
                'properties': {
                    '_timestamp': timestamp,
                    '_upsell': "true",
                    '_child': "true"
                }
            });
        }
        formData['sections'] = "main-cart,cart-drawer";

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/javascript'
            },
            body: JSON.stringify(formData)
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    return;
                }
                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                    detail: {
                        addToCartBtn: this.addToCartButton
                    },
                    bubbles: true
                }));

                resetProductPage();

            })
            .catch((e) => {
                console.error(e);
                document.getElementById('stringConfigErrorMessage').innerHTML = document.getElementById('stringConfigError').getAttribute("data-message");
                document.getElementById('stringConfigError').classList.add('active');
            });

    }
}




function setUpFilterControls() {
    // kudos https://stackoverflow.com/questions/68644260/how-to-close-details-tag-when-other-is-open-or-a-click-is-made-outside-the-tag#answer-68644266
    var details = [...document.querySelectorAll('body.template-collection .facets-sidebar details')];
    document.addEventListener('click', function(e) {
      if (!details.some(f => f.contains(e.target))) {
        details.forEach(f => f.removeAttribute('open'));
      } else {
        details.forEach(f => !f.contains(e.target) ? f.removeAttribute('open') : '');
      }
    })
}
function closeAllFilterControls() {
    var details = [...document.querySelectorAll('body.template-collection .facets-sidebar details')];
    details.forEach(f => f.removeAttribute('open'));
}
setUpFilterControls();

document.addEventListener("DOMContentLoaded", function() {
    // if remove is clicked, then disable the checkout button so any child gift wrap products can be safely removed
    document.querySelectorAll('.minicart--remove').forEach((button) => {
      button.addEventListener('click', () => {
        let checkoutButton = document.querySelector('.cart-drawer__footer button[type="submit"]');
        if(checkoutButton !== null) {
            checkoutButton.setAttribute('disabled', 'disabled');
        }
      });
    });
});